<script setup lang="ts">
import { formatPhone } from '@/utils/phone'

const props = defineProps<{
  modelValue?: string
  placeholder?: string
  type?: string
  disabled?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

function onInput(e: Event) {
  const target = e.target as HTMLInputElement
  if (props.type === 'tel') {
    const cursorPos = target.selectionStart ?? target.value.length
    const digitsBeforeCursor = (target.value.slice(0, cursorPos).match(/\d/g) ?? []).length
    const formatted = formatPhone(target.value)
    target.value = formatted
    let newPos = 0
    let digitsSeen = 0
    for (let i = 0; i < formatted.length; i++) {
      if (/\d/.test(formatted[i] ?? '')) {
        digitsSeen++
        if (digitsSeen === digitsBeforeCursor) { newPos = i + 1; break }
      }
    }
    if (digitsSeen < digitsBeforeCursor) newPos = formatted.length
    target.setSelectionRange(newPos, newPos)
    emit('update:modelValue', formatted)
  } else {
    emit('update:modelValue', target.value)
  }
}
</script>

<template>
  <input
    :value="modelValue"
    :type="type ?? 'text'"
    :placeholder="placeholder"
    :disabled="disabled"
    class="w-full bg-surface-container-high text-on-surface font-mono text-sm px-3 py-2 border border-border rounded focus:outline-none focus:ring-1 focus:ring-primary/30 placeholder:text-outline/50 disabled:opacity-40 disabled:cursor-not-allowed transition-shadow"
    @input="onInput"
  />
</template>
